<template>
  <span>
    <el-dropdown
      @command="commandColumn"
      :show-timeout="0"
      trigger="click"
    >
      <slot></slot>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :command="-1"
          class="border-b"
          >定制列组合</el-dropdown-item
        >
        <el-dropdown-item
          v-for="(myColumn, index) in myColumns"
          :key="myColumn.id"
          :command="myColumn.id"
          :class="[myColumn.used ? 'active' : '']"
        >
          <div class="columnName relative pr-[60px]">
            <div class="whitespace-nowrap overflow-hidden text-ellipsis flex-1 mr-2">{{ myColumn.name }}</div>
            <div
              v-show="myColumn.id != 0"
              class="absolute right-0 top-2"
            >
              <p>
                <i
                  class="el-icon-edit"
                  @click.stop="editColumns(myColumn)"
                ></i>
                <i
                  class="el-icon-delete"
                  @click.stop="deleColumns(myColumn)"
                ></i>
              </p>
            </div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <cusColumnDialog
      :visible.sync="showCusColumn"
      :data="editColmn"
      :sysType="sysType"
      :defaultKeys="defaultKeys"
      :fixedColumns="fixedColumns"
      @updateSuccess="() => getMyColumns(true)"
    />
  </span>
</template>
<script>
import { myColumns, setUsedColumn, columnDelete } from '@/api/multiPlatform';
import cusColumnDialog from './cusColumnDialog.vue';
export default {
  props: {
    sysType: {
      type: String,
      default: 'MULTI_PLATFORM',
    },
    defaultKeys: {
      type: Array,
      default: () => [],
    },
    // 固定列配置（不可取消选择、不可拖动）
    fixedColumns: {
      type: Object,
      default: () => ({
        campaign: ['campaign_name', 'status', 'campaign_ref', 'campaignName', 'adSecondStatus'],
        adset: ['group_name', 'status', 'groupName', 'adSecondStatus'],
        ad: ['ad_name', 'status', 'adName', 'adSecondStatus'],
        asset: [],
      }),
    },
  },
  components: {
    cusColumnDialog,
  },
  data() {
    return {
      showCusColumn: false, // 自定义列表设置
      myColumns: [],
      editColmn: {}, // 当前编辑的列数据
    };
  },
  methods: {
    getMyColumns(flag) {
      let params = {
        sysType: this.sysType,
      };
      myColumns(params).then((res) => {
        this.myColumns = res.data;
        if (flag) {
          let usedColumn = res.data.find((item) => item.used);
          // 如果当前使用的定制列配置中没有 asset 层级的列，从默认配置（id==0）中补充
          if (usedColumn && (!usedColumn.columns || !usedColumn.columns.asset || !usedColumn.columns.asset.length)) {
            const defaultColumn = res.data.find((item) => item.id == 0);
            if (
              defaultColumn &&
              defaultColumn.columns &&
              defaultColumn.columns.asset &&
              defaultColumn.columns.asset.length
            ) {
              usedColumn = JSON.parse(JSON.stringify(usedColumn));
              if (!usedColumn.columns) usedColumn.columns = {};
              usedColumn.columns.asset = defaultColumn.columns.asset;
            }
          }
          this.$emit('getCurrentColumn', usedColumn);
        }
      });
    },
    commandColumn(id) {
      if (id == -1) {
        this.editColumns();
        return;
      }
      let params = {
        id,
        sysType: this.sysType,
      };
      this.$showLoading();
      setUsedColumn(params)
        .then((res) => {
          this.$emit(
            'getCurrentColumn',
            this.myColumns.find((item) => item.id == id),
          );
          this.getMyColumns(false);
        })
        .finally(() => {
          this.$hideLoading();
        });
    },
    editColumns(column) {
      this.editColmn = column;
      this.showCusColumn = true;
    },
    deleColumns(column) {
      columnDelete({ id: column.id }).then((res) => {
        this.getMyColumns(false);
      });
    },
  },
  created() {
    this.getMyColumns(true);
  },
};
</script>
<style lang="scss" scoped>
.columnName {
  white-space: nowrap !important;
  padding-right: 60px;
}
.columnName span {
  white-space: nowrap !important;
}
</style>
